<template>
    <ul class="pagination">
        <li class="page-item" v-if="hasPreviousPage"><a href="#" @click.prevent="changePage(1)" class="page-link">&laquo;</a></li>
        <li class="page-item" v-if="hasPreviousPage"><a href="#" @click.prevent="changePage(_page - 1)" class="page-link">&#8249;</a></li>
        <li v-for="page in pages" :class="['page-item', { active: page.isActive }]"><a href="#" @click.prevent="changePage(page.name)" class="page-link">{{ page.name }}</a></li>
        <li class="page-item disabled" v-if="page < totalPages - 2"><span class="page-link"> ... </span></li>
        <li class="page-item" v-if="page < totalPages - 2"><a href="#" @click.prevent="changePage(totalPages)" class="page-link">{{ totalPages }}</a></li>
        <li class="page-item" v-if="hasNextPage"><a href="#" @click.prevent="changePage(_page + 1)" class="page-link">&#8250;</a></li>
        <li class="page-item" v-if="hasNextPage"><a href="#" @click.prevent="changePage(totalPages)" class="page-link">&raquo;</a></li>
    </ul>
</template>

<script>
    export default function(props = {}) {
        const root = this;

        return {
            // This cannot be called page otherwise it prevents a data-bound property with the same name.
            get _page() {
                return props.page;
            },
            get totalPages() {
                return props.totalPages;
            },
            get hasPreviousPage() {
                return this._page > 1;
            },
            get hasNextPage() {
                return this._page < this.totalPages;
            },
            get pages() {
                const range = [];
                for (let i = this._page <= 2 ? 1 : this._page - 2; i <= (this._page >= this.totalPages - 2 ? this.totalPages : this._page + 2); i++) {
                    range.push({
                        name: i,
                        isActive: this._page == i
                    });
                }
                return range;
            },
            mounted(element, data = this) {
                // Call the root mounted method.
                root.mounted(element, data);
            },
            unmounted(element, data = this) {
                // Call the root unmounted method.
                root.unmounted(element, data);
            },
            changePage(page, e = event) {
                e.target.dispatchEvent(new CustomEvent('page-changed', { bubbles: true, detail: page }));
            }
        };
    }
</script>